module.exports = __webpack_public_path__ + "img/anillo_doble_1.6s_150px.d1a291f0.gif";